var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "v-app",
    { attrs: { id: "inspire" } },
    [
      _c(
        "v-app-bar",
        { attrs: { app: "", color: "blue-grey lighten-2", dark: "" } },
        [
          _c("v-app-bar-nav-icon", {
            on: {
              click: function($event) {
                $event.stopPropagation()
                _vm.drawer = !_vm.drawer
              }
            }
          }),
          _vm._v(" "),
          _c("v-toolbar-title", [_vm._v("Paragon DZ")]),
          _vm._v(" "),
          _c("v-spacer"),
          _vm._v(" "),
          _c(
            "v-toolbar-items",
            { staticClass: "upper-corner" },
            [
              _c("v-avatar", { attrs: { color: "indigo", size: "36" } }, [
                _c("span", { staticClass: "white--text text-h6" }, [
                  _vm._v(_vm._s(_vm.getInitials(this.user.name)))
                ])
              ]),
              _vm._v(" "),
              _c("v-divider", { attrs: { vertical: "" } }),
              _vm._v(" "),
              _c(
                "v-btn",
                {
                  attrs: { icon: "" },
                  on: {
                    click: function($event) {
                      $event.preventDefault()
                      return _vm.logout($event)
                    }
                  }
                },
                [_c("v-icon", [_vm._v("mdi-logout-variant")])],
                1
              )
            ],
            1
          )
        ],
        1
      ),
      _vm._v(" "),
      _c(
        "v-navigation-drawer",
        {
          attrs: { app: "" },
          scopedSlots: _vm._u(
            [
              !_vm.inSettings && _vm.checkGate("settings-access")
                ? {
                    key: "append",
                    fn: function() {
                      return [
                        _c(
                          "div",
                          { staticClass: "pa-2" },
                          [
                            _c(
                              "v-btn",
                              { attrs: { block: "", to: "/settings" } },
                              [
                                _c("v-icon", [_vm._v("mdi-cog-outline")]),
                                _vm._v("   Settings\n        ")
                              ],
                              1
                            )
                          ],
                          1
                        )
                      ]
                    },
                    proxy: true
                  }
                : null
            ],
            null,
            true
          ),
          model: {
            value: _vm.drawer,
            callback: function($$v) {
              _vm.drawer = $$v
            },
            expression: "drawer"
          }
        },
        [
          _vm.inSettings
            ? _c(
                "v-btn",
                { attrs: { block: "", to: "/home" } },
                [
                  _c("v-icon", [_vm._v("mdi-keyboard-backspace")]),
                  _vm._v("   Back\n    ")
                ],
                1
              )
            : _vm._e(),
          _vm._v(" "),
          _vm.inSettings
            ? _c("NavBar", { attrs: { navLinks: _vm.SettingsNavLinks } })
            : _c("NavBar", { attrs: { navLinks: _vm.MainNavLinks } })
        ],
        1
      ),
      _vm._v(" "),
      _c(
        "v-main",
        [
          _c(
            "v-container",
            { attrs: { fluid: "" } },
            [_c("v-row", [_c("v-col", [_c("router-view")], 1)], 1)],
            1
          )
        ],
        1
      ),
      _vm._v(" "),
      _c("v-footer", { attrs: { color: "blue-grey lighten-2", app: "" } }, [
        _c("span", { staticClass: "white--text" }, [_vm._v("© 2021")])
      ])
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }